import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import MainLayOut from "./component/MainLayOut";
import { useEffect } from "react";
import Home from "./pages/Home";
import ContactUs from "./pages/contact-us/ContactUs";
import Gallery from "./pages/gallery/Gallery";
import Blog from "./pages/blog/Blog";
import About from "./pages/about/About";
import BlogDetails from "./pages/blog/BlogDetails";
import PropertyDealer from "./pages/services/PropertyDealer";
import Construction from "./pages/services/Construction";
import EventManagement from "./pages/services/EventManagement";
import FinancialAdvisor from "./pages/services/FinancialAdvisor";
import SolarEnergy from "./pages/services/SolarEnergy";
import ImportExport from "./pages/services/ImportExport";
import WebsiteDevelopment from "./pages/services/WebsiteDevelopment";
import CompanyRegistration from "./pages/services/CompanyRegistration";
import GSTRegistration from "./pages/services/GSTRegistration";
import SecurityServices from "./pages/services/SecurityServices";
import HousekeepingServices from "./pages/services/HousekeepingServices";
import ManpowerSupply from "./pages/services/ManpowerSupply";
import FacilityManagement from "./pages/services/FacilityManagement";
import ElectricalServices from "./pages/services/ElectricalServices";
import MaintenanceRepair from "./pages/services/MaintenanceRepair";
import CustomerSupport from "./pages/services/CustomerSupport";
import HealthProducts from "./pages/services/HealthProducts";
import BusinessPartnership from "./pages/services/BusinessPartnership";


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
function App() {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" exact element={<MainLayOut />}>
            <Route index element={<Home />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/our-blog" element={<Blog />} />
            <Route path="/blog-details" element={<BlogDetails />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/property-dealer" element={<PropertyDealer />} />
            <Route path="/construction" element={<Construction />} />
            <Route path="/event-management" element={<EventManagement />} />
            <Route path="/financial-advisor" element={<FinancialAdvisor />} />
            <Route path="/solar-energy" element={<SolarEnergy />} />
            <Route path="/import-export" element={<ImportExport />} />
            <Route path="/website-development" element={<WebsiteDevelopment />} />
            <Route path="/company-registration" element={<CompanyRegistration />} />
            <Route path="/gst-filing-itr-filing" element={<GSTRegistration />} />
            <Route path="/security-services" element={<SecurityServices />} />
            <Route path="/housekeeping-services" element={<HousekeepingServices />} />
            <Route path="/manpower-supply" element={<ManpowerSupply />} />
            <Route path="/facility-management" element={<FacilityManagement />} />
            <Route path="/electrical-services" element={<ElectricalServices />} />
            <Route path="/maintenance-repair" element={<MaintenanceRepair />} />
            <Route path="/customer-support" element={<CustomerSupport />} />
            <Route path="/health-products" element={<HealthProducts />} />
            <Route path="/business-partnership" element={<BusinessPartnership />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
